export default "__VITE_ASSET___$bgYlas__"